import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

/*
  este arquivo contém funções para validação de formulário com validações customizadas
*/

@Injectable({
  'providedIn': 'root'
})

export class FormHelper {

  /*
    função que irá testar se o CPF é valido
  */
  testCpf(control: AbstractControl) {
    let controlname = "cpf"

    if ((control as any).controls.cpf0 != null) {
      controlname = "cpf0"
    }

    let soma = 0;

    let cpf = control.get(controlname)?.value || control?.get('identificationNumber')?.value;

    // verifica se a variável cpf é igual a "undefined", exibindo uma msg de erro
    if (cpf === undefined) {
      return false;
    }

    // esta função retira os caracteres . e - da string do cpf, deixando apenas os números
    let strCPF = cpf.replace('.', '').replace('.', '').replace('-', '');
    // testa as sequencias que possuem todos os dígitos iguais e, se o cpf não tem 11 dígitos, retorna falso e exibe uma msg de erro
    if (strCPF === '00000000000' || strCPF === '11111111111' || strCPF === '22222222222' || strCPF === '33333333333' ||
      strCPF === '44444444444' || strCPF === '55555555555' || strCPF === '66666666666' || strCPF === '77777777777' || strCPF === '88888888888' ||
      strCPF === '99999999999' || strCPF.length !== 11) {
      control.get(controlname)?.setErrors({ invalidCpf: true });
      control.get("identificationNumber")?.setErrors({ invalidCpf: true });
    }

    // os seis blocos seguintes de funções vão realizar a validação do CPF propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
    // o DV corretamente, mostrará uma mensagem de erro ao usuário e retornará falso, para que o usário posso digitar novamente um número para ser testado

    // multiplica cada digito por numeros de 1 a 9, soma-os e multiplica-os por 10. Depois, divide o resultado encontrado por 11 para encontrar o resto
    for (let i = 1; i <= 9; i++) {
      soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }

    let resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) {
      resto = 0;
    }

    if (resto !== parseInt(strCPF.substring(9, 10))) {
      control.get(controlname)?.setErrors({ invalidCpf: true });
      control.get("identificationNumber")?.setErrors({ invalidCpf: true });
    }

    soma = 0;
    for (let k = 1; k <= 10; k++) {
      soma = soma + parseInt(strCPF.substring(k - 1, k)) * (12 - k)
    }

    resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) {
      resto = 0;
    }

    if (resto !== parseInt(strCPF.substring(10, 11))) {
      control.get(controlname)?.setErrors({ invalidCpf: true });
      control.get("identificationNumber")?.setErrors({ invalidCpf: true });
    }

    return null;
  }



  testDoc(control: AbstractControl) {
    let controlname = "doc"

    let soma = 0;

    let cpf = control.get(controlname)?.value || control?.get('identificationNumber')?.value;

    // verifica se a variável cpf é igual a "undefined", exibindo uma msg de erro
    if (cpf === undefined) {
      return false;
    }

    // esta função retira os caracteres . e - da string do cpf, deixando apenas os números
    let strCPF = cpf.replace('.', '').replace('.', '').replace('-', '');
    // testa as sequencias que possuem todos os dígitos iguais e, se o cpf não tem 11 dígitos, retorna falso e exibe uma msg de erro
    if (strCPF === '00000000000' || strCPF === '11111111111' || strCPF === '22222222222' || strCPF === '33333333333' ||
      strCPF === '44444444444' || strCPF === '55555555555' || strCPF === '66666666666' || strCPF === '77777777777' || strCPF === '88888888888' ||
      strCPF === '99999999999' || strCPF.length !== 11) {
      control.get(controlname)?.setErrors({ invalidCpf: true });
      control.get("identificationNumber")?.setErrors({ invalidCpf: true });
    }

    // os seis blocos seguintes de funções vão realizar a validação do CPF propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
    // o DV corretamente, mostrará uma mensagem de erro ao usuário e retornará falso, para que o usário posso digitar novamente um número para ser testado

    // multiplica cada digito por numeros de 1 a 9, soma-os e multiplica-os por 10. Depois, divide o resultado encontrado por 11 para encontrar o resto
    for (let i = 1; i <= 9; i++) {
      soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }

    let resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) {
      resto = 0;
    }

    if (resto !== parseInt(strCPF.substring(9, 10))) {
      control.get(controlname)?.setErrors({ invalidCpf: true });
      control.get("identificationNumber")?.setErrors({ invalidCpf: true });
    }

    soma = 0;
    for (let k = 1; k <= 10; k++) {
      soma = soma + parseInt(strCPF.substring(k - 1, k)) * (12 - k)
    }

    resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) {
      resto = 0;
    }

    if (resto !== parseInt(strCPF.substring(10, 11))) {
      control.get(controlname)?.setErrors({ invalidCpf: true });
      control.get("identificationNumber")?.setErrors({ invalidCpf: true });
    }

    return null;
  }

  /*
    verifica se a senha e o campo repetir senha conferem
  */
  testPasswordSame(control: AbstractControl) {
    if (control.value.password !== control.value.repeatPassword) {
      control.get("repeatPassword")?.setErrors({ notSame: true });
    }

    return null;
  }


  /*
    verifica se o nome é completo
  */
  testFullName(control: AbstractControl) {
    let name = control.get("name")?.value;

    if (name == null) {
      control.get("name")?.setErrors({ invalidName: true });
    }

    let parts = name.split(' ');

    if (parts.length < 2) {
      control.get("name")?.setErrors({ invalidName: true });
    }

    let sobrenome = parts[1];

    if (sobrenome == undefined) {
      control.get("name")?.setErrors({ invalidName: true });
    }

    if (sobrenome != null && sobrenome.length < 2) {
      control.get("name")?.setErrors({ invalidName: true });
    }


    return null;
  }


  /*
    verifica se os campos email e confirmar email são iguais
  */
  testEmailSame(control: AbstractControl) {
    if (control.value.email !== control.value.repeatEmail) {
      control.get("repeatEmail")?.setErrors({ notSame: true });
    }

    return null;
  }


}
